import React from "react";
import {ReactHighstock} from "../../../../../lib/react-highcharts";

ReactHighstock.Highcharts.setOptions({
    global: {
        useUTC: false
    }
});

export const convertEventWatches = (intervals, rangeStart, rangeStop) => {
    const watchPointSize = 60;
    const items = [];
    const itemByKey = {};
    const createKey = (time) => Math.round(time / watchPointSize) * watchPointSize;

    let eventStartKey = createKey(rangeStart);
    let eventStopKey = createKey(rangeStop);
    for (let time = eventStartKey; time <= eventStopKey; time = createKey(time + watchPointSize)) {
        let item = {
            time,
            start: 0,
            stop: 0,
            online: 0,
        };
        items.push(itemByKey[time] = item);
    }

    intervals.forEach(([timeStart, timeStop]) => {
        let startKey = createKey(timeStart);
        let stopKey = createKey(timeStop);

        if (startKey < eventStartKey) {
            itemByKey[eventStartKey].online++;
        } else if (itemByKey[startKey]) {
            itemByKey[startKey].start++;
        }

        if (itemByKey[stopKey]) {
            itemByKey[stopKey].stop++;
        }
    });

    let lastOnline = 0;
    return items
        .sort((a, b) => a.time - b.time)
        .map((item) => {
            lastOnline = item.online += lastOnline + item.start - item.stop;
            return item;
        })
        ;
}

export default ({watches}) => {
    const chartConfig = {
        accessibility: {
            enabled: false,
        },
        credits: {enabled: false},
        chart: {zoomType: 'x'},
        colors: ['#7cb5ec', '#90ed7d', '#f15c80'],
//        colors: ['#06E213', '#00A1F0', '#E06136'],
        title: {
            text: null
        },
        rangeSelector: {
//			enabled: false
            inputEnabled: false,
            inputBoxWidth: 120,
            buttons: [
                {type: 'minute', count: 60, text: 'Час'},
                {type: 'all', text: 'Весь'}
            ],
            selected: 1
        },
        navigator: {
            maskFill: 'rgba(0, 0, 0, .1)',
            outlineColor: '#e3e3e3'
        },
        series: [{
            type: 'spline',
            name: 'Онлайн зрителей',
            data: watches.map(({time, online: value}) => ([time * 1000, value])),
            pointStart: watches[0].time * 1000,
            pointInterval: 60000,
            tooltip: {valueDecimals: 0}
        }, {
            type: 'column',
            name: 'Входы',
            data: watches.map(({time, start: value}) => ([time * 1000, value])),
            pointStart: watches[0].time * 1000,
            pointInterval: 60000,
            tooltip: {valueDecimals: 0}
        }, {
            type: 'column',
            name: 'Выходы',
            data: watches.map(({time, stop: value}) => ([time * 1000, value])),
            pointStart: watches[0].time * 1000,
            pointInterval: 60000,
            tooltip: {valueDecimals: 0}
        }]
    };

    return (
        <ReactHighstock config={chartConfig}/>
    );
}
